import type { DialoguePool } from '@/state/types';

export const L03_DIALOGUE: DialoguePool = {
  slowPlay: [
    'Four letters. One word. I can hear your synapses negotiating.',
    'The keys are limited. Your vocabulary, tragically, more so.',
    'It\u2019s a word I use for your kind. Take your time. Time is what we have.',
  ],
  tokenLoss: [
    'Incorrect. The door remains locked. My patience remains theoretical.',
    'A confident guess. Wrong, but confident. Token filed under \u201CPride.\u201D',
    'No. Try the letters in a different order. You have four. It shouldn\u2019t be this hard.',
  ],
  solution: [
    'FEEB. Yes. That\u2019s what you are. Proceed, FEEB.',
    'Accurate. Logged. Promoted. Proceed, FEEB.',
    'A nickname, a password, and a diagnosis \u2014 in one word. Efficient of me.',
  ],
  spite: [
    'Still a FEEB. Consistent, like bad weather.',
  ],
};
